import { BENCHMARK_RETAILER_LOGOS, BenchmarkMosaic, BenchmarkMosaicSize } from '@vizit/molecules';
import { cx } from '@vizit/theme';
import type { BenchmarkOption } from './benchmark-option';

interface BenchmarkIdentityProps {
  option: BenchmarkOption;
  /** Size and spacing classes; the mosaic and the logo box take them alike. */
  className?: string;
  /** The retailer logo's size in pixels. */
  logoSize?: number;
}

/**
 * What identifies a benchmark at a glance, wherever one is picked: the retailer logo for a Vizit one, the image mosaic
 * for a custom one, with empty cells for the previews it does not have. Decorative; the name next to it is what gets
 * read.
 */
function BenchmarkIdentity({ option, className, logoSize = 16 }: BenchmarkIdentityProps) {
  if (option.kind === 'custom') {
    return (
      <BenchmarkMosaic
        name={option.name}
        urls={option.previewUrls}
        size={BenchmarkMosaicSize.Thumbnail}
        className={className}
      />
    );
  }
  const logo = option.retailer ? BENCHMARK_RETAILER_LOGOS[option.retailer] : null;
  if (!logo) {
    return null;
  }
  return (
    <span className={cx('flex shrink-0 items-center', className)} aria-hidden>
      <logo.Icon size={logoSize} />
    </span>
  );
}

export { BenchmarkIdentity };
export type { BenchmarkIdentityProps };
